/** Conversion funnels and click/scroll heatmaps. */
const en = {
  project: 'Project',
  funnel: {
    title: 'Conversion Funnel',
    pages: 'Pages',
    customEvents: 'Custom events',
    noPages: 'No pages recorded yet',
    noEvents: 'No custom events tracked yet',
    stepsPages: 'Funnel steps. Pick pages in order (e.g. / → /docs → /signup)',
    stepsEvents: 'Funnel steps. Pick tracked events in order',
    run: 'Run',
    tooltip: (sessions: number, pct: number) => `${sessions} sessions (${pct}% of start)`,
  },
  heatmap: {
    noPages: 'No recorded pages yet',
    selectGroup: 'Select a page group, loads automatically',
    selectUrl: 'Select an exact URL, loads automatically',
    groupSimilar: 'Group similar pages',
    groupSimilarHint:
      'Collapse same-template pages (e.g. /product/:id) and dev-port variants into one group',
    pageBackground: 'Page background',
    emptyGroup: 'page group',
    emptyPage: 'page',
    emptyBody: (what: string) =>
      `Pick a ${what} above to see where visitors click and how far they scroll.`,
    emptyGrouped:
      ' Pages that share a template (e.g. /product/:id) are grouped together. Turn off Group similar pages to target one exact URL.',
    sampledSessions: 'Sampled sessions',
    totalClicks: 'Total clicks',
    hottestZone: 'Hottest zone',
    clicksSuffix: (n: number) => `${n} clicks`,
    maxScroll: 'Max scroll depth',
    reachedMid: 'Reached mid-page',
    density: 'Click density. Click any hot area to see the sessions behind it.',
    scrollDepth: 'Scroll depth',
    regionTitle: 'Sessions clicking here',
    regionAround: (x: number, y: number) => `Around (${x}, ${y}) px on this page`,
    regionEmpty: 'No sampled sessions clicked this area.',
    columns: { user: 'User', clicksHere: 'Clicks here', duration: 'Duration', started: 'Started' },
  },
};

const tr: typeof en = {
  project: 'Proje',
  funnel: {
    title: 'Dönüşüm Hunisi',
    pages: 'Sayfalar',
    customEvents: 'Özel olaylar',
    noPages: 'Henüz kaydedilmiş sayfa yok',
    noEvents: 'Henüz izlenen özel olay yok',
    stepsPages: 'Huni adımları. Sayfaları sırayla seçin (örn. / → /docs → /signup)',
    stepsEvents: 'Huni adımları. İzlenen olayları sırayla seçin',
    run: 'Çalıştır',
    tooltip: (sessions: number, pct: number) => `${sessions} oturum (başlangıcın %${pct}’i)`,
  },
  heatmap: {
    noPages: 'Henüz kaydedilmiş sayfa yok',
    selectGroup: 'Bir sayfa grubu seçin, otomatik yüklenir',
    selectUrl: 'Tam bir URL seçin, otomatik yüklenir',
    groupSimilar: 'Benzer sayfaları grupla',
    groupSimilarHint:
      'Aynı şablonu paylaşan sayfaları (örn. /product/:id) ve geliştirme portu varyantlarını tek grupta toplar',
    pageBackground: 'Sayfa arka planı',
    emptyGroup: 'sayfa grubu',
    emptyPage: 'sayfa',
    emptyBody: (what: string) =>
      `Ziyaretçilerin nereye tıkladığını ve ne kadar kaydırdığını görmek için yukarıdan bir ${what} seçin.`,
    emptyGrouped:
      ' Aynı şablonu paylaşan sayfalar (örn. /product/:id) birlikte gruplanır. Tam bir URL’yi hedeflemek için Benzer sayfaları grupla’yı kapatın.',
    sampledSessions: 'Örneklenen oturum',
    totalClicks: 'Toplam tıklama',
    hottestZone: 'En yoğun bölge',
    clicksSuffix: (n: number) => `${n} tıklama`,
    maxScroll: 'En fazla kaydırma',
    reachedMid: 'Sayfa ortasına ulaşan',
    density: 'Tıklama yoğunluğu. Arkasındaki oturumları görmek için sıcak bir alana tıklayın.',
    scrollDepth: 'Kaydırma derinliği',
    regionTitle: 'Buraya tıklayan oturumlar',
    regionAround: (x: number, y: number) => `Bu sayfada yaklaşık (${x}, ${y}) px`,
    regionEmpty: 'Örneklenen oturumlardan hiçbiri bu alana tıklamamış.',
    columns: { user: 'Kullanıcı', clicksHere: 'Buradaki tıklama', duration: 'Süre', started: 'Başlangıç' },
  },
};

export const analytics = { en, tr };
